import { useCallback } from "react";

import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import * as m from "@bokio/mobile-web-shared/core/model/model";
import { useLazyApi } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";

import type { RequestState } from "@bokio/mobile-web-shared/services/api/requestState";

import AnalyticsEventCategory = m.Bokio.Common.Contract.Metrics.Analytics.Requests.AnalyticsEventCategory;
export { AnalyticsEventCategory };

type UseMetric = [
	(
		Category: AnalyticsEventCategory,
		Action: string,
		Label?: string,
		Value?: number,
	) => Promise<m.Envelope<boolean, m.SimpleError>>,
	RequestState<m.Envelope<boolean, m.SimpleError>>,
];

export const useMetric = (): UseMetric => {
	const {
		companyInfo: { Id: companyId },
	} = useCompanyInfo();
	const [execute, request] = useLazyApi(proxy.Bokio.Common.Web.Metrics.MetricsController.SaveAnalytics.Post);

	const addMetric = useCallback(
		(Category: AnalyticsEventCategory, Action: string, Label?: string, Value?: number) =>
			execute(companyId, { Category, Action, Label, Value }),
		[companyId, execute],
	);

	return [addMetric, request];
};
